<template>
    <div class="accPhone">
        <div>当前绑定手机<span>{{mobile}}</span></div>
        <div class="accPhoneTip">修改手机号，请到小程序端"我的-设置"中，选择账号与安全，进行修改</div>
        <div class="goWechat">{{mobile?'修改':'绑定'}}手机：<img class="weChatCode" :src="weChatCode" alt=""></div>
    </div>
</template>

<script>
    import { getWeChatCode } from '@/js/common.js'

    export default {
        data() {
            return {
                mobile: '',
                weChatCode: ''
            }
        },
        mounted() {
            let members = JSON.parse(this.Cookies.get('members'))
            if(members.mobile) {
                this.mobile = members.mobile
            } else {
                this.mobile = '未绑定'
            }
            getWeChatCode(this, 'accountNumber/pages/index/accountNumber', '1')
        }
    }
</script>

<style lang="scss" scoped>
    .accPhone {
        padding: 40px;
        font-size: 14px;
        span {
            color: #9fa3b0;
            margin-left: 30px;
        }
        .accPhoneTip {
            padding-top: 30px;
        }
        .goWechat {
            padding-top: 20px;
            font-size: 14px;
            .weChatCode {
                width: 150px;
                vertical-align: middle;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/accPhone/index.vue